import { RouteInfo, Role } from '@meddatacore/common';

const QUEUE_ADMIN_MODULES: RouteInfo[] = [
  {
    path: 'queue-admin/manuals',
    title: 'QUEUE.HOME',
    moduleName: '',
    rootModuleName: '',
    iconType: 'material-icons-two-tone',
    icon: 'home',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.Admin],
    submenu: [],
  },
];

export const QUEUE_CLINIC_ADMIN_MODULES: RouteInfo[] = [
  {
    path: '/queue-back',
    title: 'QUEUE.HOME',
    moduleName: 'queue-home',
    rootModuleName: 'queue-back',
    iconType: 'material-icons-two-tone',
    icon: 'home',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: [],
  },
  {
    path: '/queue-back/executor',
    title: 'QUEUE.MENU.EXECUTORS',
    moduleName: 'workplace',
    rootModuleName: 'queue-back',
    iconType: 'fas fa-hospital-user',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/work-place',
    title: 'QUEUE.MENU.WORKPLACE',
    moduleName: 'workplace',
    rootModuleName: 'queue-back',
    iconType: 'fas fa-hospital-user',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/registrator-menu',
    title: 'QUEUE.MENU.REGISTRATOR_MENU',
    moduleName: 'registrator-menu',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-bars',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/registrator',
    title: 'QUEUE.MENU.REGISTRATORS',
    moduleName: 'registrator',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-laptop-medical',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '',
    title: 'QUEUE.MENU.INFO_SCREEN',
    moduleName: 'screen',
    rootModuleName: 'queue-back',
    iconType: 'material-icons-two-tone',
    icon: 'home',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: [
      {
        path: '/queue-back/screen',
        title: 'QUEUE.MENU.SCREEN',
        moduleName: 'screen',
        rootModuleName: 'queue-back',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: [],
      },
      {
        path: '/queue-back/screen-profile',
        title: 'QUEUE.MENU.SCREEN_PROFILE',
        moduleName: 'screen-profile',
        rootModuleName: 'queue-back',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: [],
      },
      {
        path: '/queue-back/queue-group',
        title: 'QUEUE.MENU.QUEUE_GROUP',
        moduleName: 'queue-group',
        rootModuleName: 'queue-back',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: [],
      },
    ],
  },
  {
    path: '/queue-back/sequence',
    title: 'QUEUE.MENU.SEQUENCE',
    moduleName: 'sequence',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-briefcase',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/voice-profile',
    title: 'Голосовые профили',
    moduleName: 'voiceProfile',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-briefcase',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/queue-type',
    title: 'QUEUE.MENU.QUEUE_TYPE',
    moduleName: 'queueType',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-briefcase',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-back/queue-profile',
    title: 'QUEUE.MENU.QUEUE_PROFILE',
    moduleName: 'queueProfile',
    rootModuleName: 'queue-back',
    iconType: 'fa fa-briefcase',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin],
    submenu: []
  }
];
export const QUEUE_TENANT_EMPLOYEE_MODULES: RouteInfo[] = [
  {
    path: '/queue-front',
    title: 'QUEUE.HOME',
    moduleName: 'home',
    rootModuleName: 'queue-front',
    iconType: 'material-icons-two-tone',
    icon: 'home',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.Doctor, Role.TenantAdmin],
    submenu: [],
  },
  {
    path: '/queue-front/customers/pre-registrations',
    title: 'QUEUE.MENU.PREREGISTRATIONS',
    moduleName: 'customer',
    rootModuleName: 'queue-front',
    iconType: 'fas fa-hospital-user',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.Doctor, Role.TenantAdmin],
    submenu: []
  },
  {
    path: '/queue-front/service',
    title: 'QUEUE.MENU.SERVICE',
    moduleName: 'registrator-menu',
    rootModuleName: 'queue-front',
    iconType: 'fa fa-bars',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin,Role.TenantAdmin],
    submenu: []
  },
  // {
  //   path: '/queue-front/customers-vip',
  //   title: 'QUEUE.MENU.CUSTOMERS_VIP',
  //   moduleName: 'registrator-menu',
  //   rootModuleName: 'queue-front',
  //   iconType: 'fa fa-bars',
  //   icon: '',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [Role.TenantAdmin,Role.TenantAdmin],
  //   submenu: []
  // },
  {
    path: '/queue-front/monitoring-queue',
    title: 'QUEUE.MENU.MONITORING_QUEUE',
    moduleName: 'registrator-menu',
    rootModuleName: 'queue-front',
    iconType: 'fa fa-bars',
    icon: '',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [Role.TenantAdmin,Role.TenantAdmin],
    submenu: []
  },

];

export const ROUTES: RouteInfo[] = [

  ...QUEUE_ADMIN_MODULES,
  ...QUEUE_CLINIC_ADMIN_MODULES,
  ...QUEUE_TENANT_EMPLOYEE_MODULES

];
